module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-align-center flex-pack-center register-form"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "register"
  }, [_c('div', {
    staticClass: "returnBtn",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          path: '/login'
        })
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-return"
  })]), _vm._v(" "), _c('div', {
    staticClass: "title",
    domProps: {
      "textContent": _vm._s(_vm.status ? '重置密码' : '注册')
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.register.apply(null, arguments)
      }
    }
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "user",
    attrs: {
      "type": "tel",
      "placeholder": "请输入您的手机号码"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "codeBox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "code",
    attrs: {
      "type": "tel",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.isGetCode) ? _c('span', {
    staticClass: "sendCode",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v("获取验证码")]) : _vm._e(), _vm._v(" "), (_vm.isGetCode) ? _c('span', {
    staticClass: "sendCode"
  }, [_vm._v(_vm._s(_vm.time + ' s'))]) : _vm._e()]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "password",
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "getCodeTip",
    style: ({
      'visibility': (_vm.isShowCodeTip ? 'visible' : 'hidden')
    })
  }, [_vm._v("已发送验证码至您的手机")]), _vm._v(" "), _c('div', {
    staticClass: "confirmBtn"
  }, [_c('button', {
    attrs: {
      "type": "submit"
    },
    domProps: {
      "textContent": _vm._s(_vm.status ? '提交' : '下一步')
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/login/logo2.png"),
      "height": "56",
      "width": "184",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-645eec85","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/register/register.vue
// module id = 952
// module chunks = 1